/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_With_TechnologyInputs */

const en_onboarding_results_with_technology = /** @type {(inputs: Onboarding_Results_With_TechnologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`with Listening's advanced technology`)
};

const es_onboarding_results_with_technology = /** @type {(inputs: Onboarding_Results_With_TechnologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`con la tecnología avanzada de Listening`)
};

/**
* | output |
* | --- |
* | "with Listening's advanced technology" |
*
* @param {Onboarding_Results_With_TechnologyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_with_technology = /** @type {((inputs?: Onboarding_Results_With_TechnologyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_With_TechnologyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_with_technology(inputs)
	return en_onboarding_results_with_technology(inputs)
});